
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!happypack/loader?id=1!happypack/loader?id=2!sass-resources-loader?{\"resources\":[\"./app/scss/settings/params.scss\",\"./app/scss/settings/mixins.scss\"]}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6077cb19\",\"scoped\":true,\"hasInlineConfig\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KrossingObject.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KrossingObject.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6077cb19\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KrossingObject.vue"),
  /* scopeId */
  "data-v-6077cb19",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/elements/KrossingObject.vue
// module id = 195
// module chunks = 0